'use client'
import { createContext, useContext as useReactContext } from 'react'
import { NormalizedConfiguration } from '@/types/Configuration'

export const PageContext = createContext<NormalizedConfiguration | undefined>(
  undefined
)

// Custom hook to ensure context is used within provider
export const usePageContext = (): NormalizedConfiguration => {
  const context = useReactContext(PageContext)
  if (context === undefined) {
    return {} as NormalizedConfiguration
    // throw new Error('useAuth must be used within an AuthenticatedProvider')
  }
  return context
}

const PageProvider = ({
  children,
  config,
  isHomepage,
}: {
  children: React.ReactNode
  config: NormalizedConfiguration
  isHomepage: boolean
}) => {
  return (
    <PageContext.Provider
      value={
        {
          ...config,
          isHomepage,
        } as NormalizedConfiguration
      }
    >
      {children}
    </PageContext.Provider>
  )
}

export { PageProvider }
